import { db } from "../firebase";
import { collection, getDocs, query, where } from "firebase/firestore";

async function getOrgOrders(orgId, startDate, endDate) {
  try {
    const now = Date.now();
    const thirtyDaysAgo = (now - 30 * 24 * 60 * 60 * 1000).toString();

    let q;

    if (startDate && endDate) {
      q = query(
        collection(db, "Orders"),
        where("orgId", "==", orgId),
        where("createdAt", ">=", startDate.toString()),
        where("createdAt", "<=", endDate.toString()),
      );
    } else {
      q = query(
        collection(db, "Orders"),
        where("orgId", "==", orgId),
        where("createdAt", ">=", thirtyDaysAgo),
      );
    }

    const querySnapshot = await getDocs(q);
    const orders = querySnapshot.docs
      .map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }))
      .filter(
        (order) =>
          Array.isArray(order.products) &&
          order.products.some((product) => product?.linesIds?.length > 0),
      );

    return orders;
  } catch (error) {
    console.error("Error fetching org orders:", error);
    throw error;
  }
}

export default getOrgOrders;
